export const LISTER_TYPES = {
  FETCH_LISTER_BEGIN: 'FETCH_LISTER_BEGIN',
  FETCH_LISTER_ERROR: 'FETCH_LISTER_ERROR',
  FETCH_LISTER_SUCCESS: 'FETCH_LISTER_SUCCESS',
};
